// extracted by mini-css-extract-plugin
export var actionButton = "_l4-t";
export var buttonContainer = "_l4-0";
export var buttonContainer2 = "_l4-1";
export var buttonSection = "_l4-2";
export var details = "_l4-3";
export var dropdownItem = "_l4-5";
export var dropdownItemsContainer = "_l4-4";
export var fileInput = "_l4-r";
export var headerButton = "_l4-6";
export var icon = "_l4-7";
export var input = "_l4-8";
export var macroListItem = "_l4-9";
export var mainContent = "_l4-a";
export var microText = "_l4-b";
export var modal = "_l4-w";
export var optionsButton = "_l4-c";
export var paperclip = "_l4-s";
export var pillContent = "_l4-d";
export var preview = "_l4-e";
export var preview2 = "_l4-f";
export var quillEditor = "_l4-q";
export var selectedMacro = "_l4-g";
export var sidebar = "_l4-h";
export var sidebarHeader = "_l4-j";
export var sidebarList = "_l4-i";
export var sidebarListItem = "_l4-k";
export var sidebarSearch = "_l4-l";
export var snoozeDurationWrapper = "_l4-v";
export var statusPillContainer = "_l4-m";
export var tagsContainer = "_l4-n";
export var unselectedMacro = "_l4-o";
export var variable = "_l4-u";
export var wrapper = "_l4-p";